import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import "./table.scss"

const Table = (props) => {
  const {
    columnRefs = [],
    dataTable = [],
    noDataText,
    expandRow,
    selectRow,
    loading = false
  } = props

  return (
    <>
      <BootstrapTable
        keyField='id'
        responsive
        data={dataTable || []}
        columns={columnRefs}
        loading={loading}
        noDataIndication={() => noDataText}
        {...(expandRow && { expandRow: expandRow })}
        {...(selectRow && { selectRow: selectRow })}
      />
      {/* {console.log(props)} */}
      {/* {dataTable.length === 0 &&
        <tbody className='table-body-container'>
          <tr className='empty-body'>
            <th colSpan={5}>Belum Ada Katalog Lagu</th>
          </tr>
        </tbody>
      } */}
    </>
  )
}

export default Table